(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tipsy-support-hint')) {
    customElements.define('tipsy-support-hint', class extends HTMLElement {
      connectedCallback() {
        this.formArea = this.closest('[data-tipsy-contact]');
        this.inquiry = this.formArea?.querySelector('[data-product-support-choice]');
        this.message = this.formArea?.querySelector('[data-support-message]');
        if (!this.inquiry) return;
        this.updateHint = () => {
          this.hidden = this.inquiry.value !== this.dataset.inquiryValue;
          if (this.message) {
            if (this.hidden) this.message.removeAttribute('aria-describedby');
            else this.message.setAttribute('aria-describedby', this.id);
          }
        };
        this.inquiry.addEventListener('change', this.updateHint);
        this.updateHint();
      }
      disconnectedCallback() {
        this.inquiry?.removeEventListener('change', this.updateHint);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-custom-sale-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tipsy-custom-sale-popup')) {
    const shownCampaigns = new Set();
    customElements.define('tipsy-custom-sale-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog?.showModal) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.storageKey = 'tipsy:black-friday:2026:m-series-custom-design';
        this.editor = this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
        this.attempts = 0;
        this.dialog.addEventListener('close', () => this.finishClose(), options);
        this.dialog.addEventListener('pointerdown', event => { this.backdropStart = event.target === this.dialog && this.outsideDialog(event); }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target.closest('[data-popup-close], a[href]') || (this.backdropStart && event.target === this.dialog && this.outsideDialog(event))) this.close();
          this.backdropStart = false;
        }, options);
        if (this.editor) {
          document.addEventListener('shopify:section:select', event => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open(true);
          }, options);
          document.addEventListener('shopify:section:deselect', event => {
            if (event.detail.sectionId === this.dataset.sectionId) this.close();
          }, options);
          return;
        }
        if (this.hasSeen()) return;
        const begin = () => this.schedule(Math.max(3, Math.min(15, Number(this.dataset.delay) || 5)) * 1000);
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin, { ...options, once: true });
        else begin();
      }
      hasSeen() {
        if (shownCampaigns.has(this.storageKey)) return true;
        try { return sessionStorage.getItem(this.storageKey) === 'shown'; } catch { return false; }
      }
      schedule(delay) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.attemptOpen(), delay);
      }
      hasOtherDialog() {
        return [...document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"]')].some(element => {
          if (this.contains(element) || element.closest('[hidden], [aria-hidden="true"]')) return false;
          const rect = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          return style.visibility !== 'hidden' && style.display !== 'none' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
        });
      }
      attemptOpen() {
        this.timer = null;
        if (!this.isConnected || this.opened || this.dismissed || this.hasSeen()) return;
        this.attempts += 1;
        if (!this.open(false) && this.attempts < 15) this.schedule(2000);
      }
      open(editorPreview) {
        if (!this.isConnected || this.dialog.open || document.visibilityState !== 'visible' || this.hasOtherDialog()) return false;
        if (!editorPreview && (this.opened || this.dismissed || this.hasSeen())) return false;
        this.returnFocus = document.activeElement;
        try { this.dialog.showModal(); } catch { return false; }
        if (!this.dialog.open) return false;
        clearTimeout(this.timer);
        this.scrollStyles = [document.documentElement, document.body].map(element => ({ element, value: element.style.getPropertyValue('overflow'), priority: element.style.getPropertyPriority('overflow') }));
        this.scrollStyles.forEach(({ element }) => element.style.setProperty('overflow', 'hidden'));
        this.dialog.querySelector('[data-popup-close]')?.focus({ preventScroll: true });
        if (!editorPreview) {
          this.opened = true;
          shownCampaigns.add(this.storageKey);
          try { sessionStorage.setItem(this.storageKey, 'shown'); } catch {}
        }
        return true;
      }
      outsideDialog(event) {
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }
      close() {
        if (this.dialog?.open) this.dialog.close();
        this.finishClose();
      }
      finishClose() {
        if (this.dialog?.open) return;
        this.dismissed = true;
        clearTimeout(this.timer);
        this.scrollStyles?.forEach(({ element, value, priority }) => {
          if (element.style.getPropertyValue('overflow') !== 'hidden') return;
          if (value) element.style.setProperty('overflow', value, priority);
          else element.style.removeProperty('overflow');
        });
        this.scrollStyles = null;
        if (this.returnFocus?.isConnected && (this.dialog.contains(document.activeElement) || document.activeElement === document.body)) this.returnFocus.focus?.({ preventScroll: true });
        this.returnFocus = null;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.close();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tipsy-shopping-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tipsy-compare')) {
  customElements.define('tipsy-compare', class extends HTMLElement {
    connectedCallback() {
      this.selects = [...this.querySelectorAll('[data-compare-select]')];
      this.onChange = () => this.update();
      this.addEventListener('change', this.onChange);
      this.update();
    }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }
    update() {
      const selected = this.selects.map(select => select.value);
      this.querySelectorAll('[data-compare-col]').forEach(cell => { cell.hidden = !selected.includes(cell.dataset.compareCol); });
      this.selects.forEach((select, index) => {
        [...select.options].forEach(option => { option.disabled = option.value === selected[1-index]; });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
